import { getDateRangeStore } from '../../store/store';

/**
 * Get the cache date range
 */
export default function getDateRange() {
    return getDateRangeStore().getDateRange();
}
